export default __webpack_public_path__ + "locales/ru/Common.json?hash=c57f63ce075ae09925a4e7cf01b34722";